module.exports = __webpack_public_path__ + "static/media/location.babd1ef4.svg";